<template>
    <div>
        <van-popup
            v-model="dsShow"
            :style="{ width:'90%',maxWidth:'320px',height: 'auto', borderRadius:'0.2rem' }"
            class="ds-pop pd-a"
            close-icon="close"
            closeable
        >
            <van-skeleton title avatar :row="8" class="mg-y" v-if="loading" />
            <div v-else-if="dashi">
                <div class="flex-x">
                    <van-image
                        class="avatar"
                        width="4rem"
                        height="4rem"
                        style="min-width:4rem;border-radius:5px;"
                        :src="dashi.avatar"
                    />
                    <div class="fe-full txt-l mg-l">
                        <div class="txt-bold txt-d-orange">{{dashi.nickname}}</div>
                        <small class="txt-row2 txt-gray pds-t">{{dashi.intro||'师傅暂无介绍！'}}</small>
                    </div>
                </div>
                <div class="flex-x fe-m pd-a mg-a">
                    <label>师傅微信：</label>
                    <div class="fe-full txt-l mg-l txt-d-red txt-bold">{{dashi.weixin}}</div>
                    <van-button
                        type="primary"
                        size="small"
                        class="copywx"
                        :data-clipboard-text="dashi.weixin"
                        @click="copyStr('.copywx')"
                    >复制</van-button>
                </div>
                <div class="flex-y fe-m" style="min-height:180px;" v-if="dashi.qrcode">
                    <van-image :src="dashi.qrcode" width="60%"></van-image>
                    <div>微信扫描二维码</div>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
//import axios from "../axios";
import { mapState } from "vuex";
import ClipboardJS from "clipboard";
export default {
    name: "dashi",
    props: {
        show: Boolean,
    },
    data() {
        return {
            loading: true,
            dsShow: false,
            dashi: null,
        };
    },
    watch: {
        show() {
            this.dsShow = !this.dsShow;
            if (!this.dashi && this.dsShow) {
                this.loadDashi();
            }
        },
    },
    onLoad(prm) {
        console.log(prm);
    },
    computed: {
        ...mapState(["sellid"]),
    },
    mounted() {
        ////console.log("++", this.show);
    },
    methods: {
        loadDashi() {
            this.jsonp(
                "//www.qixingtang.com/dashi.aspx" +
                    (this.sellid ? "?sellid=" + this.sellid : "")
            )
                .then((res) => {
                    this.loading = false;
                    //console.log(res.data);
                    if (res.code == 1) {
                        this.dashi = res.data;
                    } else {
                        //console.log(res);
                    }
                })
                .catch(() => {
                    this.loading = false;
                    this.dashi = { status: 0, msg: "网络错误！" };
                });
        },
        jsonp(url) {
            return new Promise((resolve, reject) => {
                window.jsonCallBack = (result) => {
                    resolve(result);
                };
                try {
                    var JSONP = document.createElement("script");
                    JSONP.type = "text/javascript";
                    JSONP.src =
                        url +
                        (url.indexOf("?") >= 0 ? "&" : "?") +
                        "callback=jsonCallBack";
                    document.getElementsByTagName("head")[0].appendChild(JSONP);
                    setTimeout(() => {
                        document
                            .getElementsByTagName("head")[0]
                            .removeChild(JSONP);
                    }, 500);
                } catch (e) {
                    reject();
                }
            });
        },
        copyStr(elm) {
            let isTouch = "ontouchstart" in window ? true : false;
            let copy = new ClipboardJS(elm);
            copy.on("success", () => {
                //console.log(e)
                this.$dialog
                    .confirm({
                        message:
                            "微信号已成功复制！" +
                            (isTouch
                                ? "请点击跳转到微信，或手动切换到微信添加师傅！"
                                : ""),
                        confirmButtonText: "跳到微信",
                        showConfirmButton: isTouch,
                    })
                    .then(() => {
                        location.href = "weixin://";
                    })
                    .catch(() => {});
            });
            copy.on("error", () => {
                this.loadDashi();
                this.$dialog.alert({
                    message: "复制失败，请长按微信号进行进制！",
                });
            });
        },
    },
};
</script>

<style>
.ds-pop .avatar {
    min-width: 4rem;
}
.ds-pop .avatar img {
    border-radius: 5px;
}
</style>